import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinsiddhatekganpati() {



const cardData =
  {
    keyword: 'Bus On Rent in Siddhatek Ganpati',
    heading: 'Sanavi Travels: Bus On Rent in Siddhatek Ganpati',
    headingDescription: 'Sanavi Travels offers reliable, well-organized, and professionally managed Bus On Rent in Siddhatek Ganpati, catering especially to pilgrims, families, senior citizen groups, corporate spiritual tours, school trips, and outstation travelers. Siddhatek Ganpati is one of the sacred Ashtavinayak temples of Maharashtra, attracting thousands of devotees throughout the year from Pune, Mumbai, Solapur, Ahmednagar, and surrounding regions. Due to high footfall during weekends, festivals, Ganesh Chaturthi, and Angarki Chaturthi, organized group transportation becomes essential for a peaceful and hassle-free darshan experience. To meet these needs, we provide a wide range of AC buses, Non-AC buses, luxury coaches, mini buses, and large seating-capacity buses suitable for short pilgrimage trips as well as long-distance religious tours. Every bus is regularly maintained with clean interiors, comfortable seating, smooth suspension, proper ventilation, and adequate luggage space for prasad and personal belongings. ',

    top: 'Top Places to Visit Near Siddhatek Ganpati with Sanavi Travels',


"topPlaces": [
  {
    "title": "Siddhatek Ganpati Temple",
    "description": "Siddhatek Ganpati Temple is one of the revered Ashtavinayak shrines dedicated to Lord Ganesha and holds immense spiritual importance among devotees. Pilgrims believe that visiting Siddhatek fulfills wishes and removes obstacles from life. The temple attracts large groups of families, senior citizens, and spiritual organizations, especially on Angarki Chaturthi and Ganesh festival days. Bus rentals are widely preferred to ensure safe, coordinated, and peaceful group travel to the temple."
  },
  {
    "title": "Bhima River Ghat",
    "description": "The Bhima River flows near Siddhatek, offering a calm and sacred atmosphere for devotees who perform rituals and take holy dips. Many pilgrimage groups include river visits as part of their religious itinerary. Hiring a bus allows groups to move comfortably between the temple and river ghats without time pressure or parking difficulties."
  },
  {
    "title": "Daund Connectivity",
    "description": "Daund serves as a major junction for devotees traveling to Siddhatek Ganpati from Pune, Solapur, and Ahmednagar. Many pilgrimage buses pass through Daund, making it an important stop for food, rest, and regrouping. Bus hire services ensure smooth and timely connectivity between Daund and Siddhatek."
  },
  {
    "title": "Indapur and Rural Temple Circuit",
    "description": "Siddhatek lies close to Indapur taluka, allowing devotees to combine Siddhatek Ganpati darshan with visits to nearby rural temples and spiritual sites. Group bus travel helps pilgrims follow temple circuits comfortably within a single day or multi-day plan."
  },
  {
    "title": "Ashtavinayak Pilgrimage Route",
    "description": "Siddhatek Ganpati is an essential stop in the Ashtavinayak Yatra, often visited along with Morgaon, Theur, Ranjangaon, and Ozar. Bus rentals are ideal for Ashtavinayak tours, ensuring all devotees travel together safely and complete darshan schedules efficiently."
  },
  {
    "title": "Pune–Solapur Highway Access",
    "description": "The Pune–Solapur Highway provides excellent road connectivity to Siddhatek, making it accessible for long-distance pilgrimage groups. Bus hire services ensure safe highway travel, reduced fatigue, and organized movement for large groups."
  },
  {
    "title": "Village Surroundings and Rural Landscape",
    "description": "The serene rural environment around Siddhatek offers devotees peace and spiritual calm away from city crowds. Group travelers often appreciate relaxed travel by bus, allowing them to enjoy the surroundings without logistical stress."
  },
  {
    "title": "Festival Travel During Ganeshotsav",
    "description": "During Ganesh Chaturthi and Angarki days, Siddhatek witnesses massive pilgrim inflow. Buses are the most practical transport option during festivals, helping manage crowds, parking limitations, and travel discipline."
  },
  {
    "title": "Senior Citizen and Bhajan Mandal Tours",
    "description": "Senior citizen groups and bhajan mandals frequently visit Siddhatek for spiritual programs. Bus rentals provide safe seating, comfortable rides, and easy boarding, making travel convenient for elderly devotees."
  },
  {
    "title": "Outstation Devotional Travel",
    "description": "Many pilgrims travel from Mumbai, Pune, Solapur, and Ahmednagar for Siddhatek darshan. Outstation bus rentals ensure smooth long-distance travel with rest stops, safety, and group coordination."
  }
]
,



"services": [
{
"name": "Bus On Rent in Siddhatek Ganpati",
"description": "Bus On Rent in Siddhatek Ganpati provides safe, comfortable, and well-organized transportation for pilgrimage groups, families, and spiritual organizations. This service is ideal for temple darshan, Ashtavinayak tours, senior citizen trips, and festival travel. Our buses are equipped with clean interiors, cushioned seating, smooth suspension, proper ventilation, and sufficient luggage space for prasad and belongings. Experienced drivers ensure disciplined driving, timely pickups, and smooth navigation on village roads and highways, making the pilgrimage journey peaceful and stress-free."
},
{
"name": "Bus Hire Siddhatek Ganpati",
"description": "Bus Hire Siddhatek Ganpati offers flexible rental solutions for one-day darshan trips, overnight pilgrimages, and multi-temple tours. With reliable buses and professional drivers, it ensures organized and comfortable group travel."
},
{
"name": "AC Bus Rental Siddhatek Ganpati",
"description": "AC Bus Rental Siddhatek Ganpati is perfect for summer pilgrimages and long-distance travel, providing air-conditioned comfort, relaxed seating, and reduced travel fatigue for devotees."
},
{
"name": "Non AC Bus on Rent Siddhatek Ganpati",
"description": "Non AC Bus on Rent Siddhatek Ganpati offers economical transportation for short pilgrimage routes, rural temple visits, and budget-friendly group travel."
},
{
"name": "Luxury Bus on Rent Siddhatek Ganpati",
"description": "Luxury Bus on Rent Siddhatek Ganpati delivers premium comfort with modern interiors, enhanced seating, and superior ride quality, ideal for VIP devotees and special spiritual tours."
},
{
"name": "Mini Bus Hire Siddhatek Ganpati",
"description": "Mini Bus Hire Siddhatek Ganpati is suitable for small to medium-sized pilgrimage groups, families, and bhajan mandals, offering flexibility and cost efficiency."
},
{
"name": "32 Seater Bus on Rent Siddhatek Ganpati",
"description": "32 Seater Bus on Rent Siddhatek Ganpati supports medium-sized pilgrimage groups with balanced seating capacity, comfort, and safety."
},
{
"name": "35 Seater Bus Hire Siddhatek Ganpati",
"description": "35 Seater Bus Hire Siddhatek Ganpati is ideal for large darshan groups, festival travel, and Ashtavinayak tours, ensuring organized seating and smooth travel."
},
{
"name": "Bus on Rent Siddhatek Ganpati for Wedding",
"description": "Bus on Rent Siddhatek Ganpati for Wedding supports wedding parties visiting the temple for blessings, ensuring coordinated and punctual guest transportation."
},
{
"name": "Bus on Rent Siddhatek Ganpati for Corporate",
"description": "Bus on Rent Siddhatek Ganpati for Corporate caters to corporate spiritual outings, employee pilgrimages, and group retreats with professional service."
},
{
"name": "Bus on Rent Siddhatek Ganpati for Picnic",
"description": "Bus on Rent Siddhatek Ganpati for Picnic provides safe and comfortable group travel for family outings and leisure trips combined with temple visits."
},
{
"name": "Bus Rental Siddhatek Ganpati Outstation",
"description": "Bus Rental Siddhatek Ganpati Outstation offers dependable long-distance transportation from Pune, Mumbai, Solapur, and nearby cities with comfort and safety."
},
{
"name": "Bus Hire Siddhatek Ganpati with Driver",
"description": "Bus Hire Siddhatek Ganpati with Driver provides chauffeur-driven buses where experienced drivers manage routes, traffic, and timing, allowing devotees to focus on worship."
},
{
"name": "Affordable Bus Rental Siddhatek Ganpati",
"description": "Affordable Bus Rental Siddhatek Ganpati delivers cost-effective pilgrimage transport without compromising cleanliness, safety, or reliability."
},
{
"name": "Best Bus Service Siddhatek Ganpati",
"description": "Best Bus Service Siddhatek Ganpati is trusted for punctual service, clean buses, disciplined drivers, and transparent pricing provided by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Siddhatek Ganpati", "Bus Hire Siddhatek Ganpati"],
["AC Bus Rental Siddhatek Ganpati", "Non AC Bus Hire Siddhatek Ganpati"],
["Luxury Bus Siddhatek Ganpati", "Mini Bus Hire Siddhatek Ganpati"],
["32 Seater Bus Siddhatek Ganpati", "35 Seater Bus Siddhatek Ganpati"],
["Wedding Bus Siddhatek Ganpati", "Corporate Bus Siddhatek Ganpati"],
["Picnic Bus Siddhatek Ganpati", "Outstation Bus Siddhatek Ganpati"],
["Bus Hire Siddhatek Ganpati with Driver", "Affordable Bus Rental Siddhatek Ganpati"],
["Best Bus Service Siddhatek Ganpati", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Siddhatek Ganpati with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels specializes in pilgrimage-focused bus rental services in Siddhatek Ganpati."
  },
  {
    "WhyChooseheading": "Pilgrim-Friendly Buses",
    "WhyChoosedescription": "Comfortable seating and smooth rides suitable for senior citizens and families."
  },
  {
    "WhyChooseheading": "Experienced Temple Route Drivers",
    "WhyChoosedescription": "Drivers are familiar with Siddhatek routes, river crossings, and festival traffic."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges for pilgrimage groups."
  },
  {
    "WhyChooseheading": "24/7 Support",
    "WhyChoosedescription": "Round-the-clock assistance for darshan scheduling and travel support."
  },
  {
    "WhyChooseheading": "Flexible Pilgrimage Packages",
    "WhyChoosedescription": "One-day, overnight, and Ashtavinayak tour packages available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every pilgrimage journey."
  },
  {
    "WhyChooseheading": "On-Time Darshan Travel",
    "WhyChoosedescription": "Punctual pickups ensure stress-free temple visits."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental for Siddhatek Ganpati darshan?',
    answer: 'Yes, Sanavi Travels offers dedicated bus rental services for Siddhatek Ganpati pilgrimage.'
  },
  {
    question: 'Is bus hire available for Ashtavinayak tours?',
    answer: 'Yes, we provide buses for complete Ashtavinayak pilgrimage tours.'
  },
  {
    question: 'Are buses suitable for senior citizens?',
    answer: 'Yes, our buses offer comfortable seating and smooth rides ideal for senior citizens.'
  },
  {
    question: 'Can I book a bus from Pune or Mumbai to Siddhatek?',
    answer: 'Yes, outstation bus rentals from Pune, Mumbai, and nearby cities are available.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Kulkarni',
    feedback: 'We booked a bus for Siddhatek Ganpati darshan. Very peaceful and well-managed journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Lata Deshpande',
    feedback: 'Excellent service for our Ashtavinayak tour. Clean bus and very polite driver.',
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Siddhatek Ganpati - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Siddhatek Ganpati for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Siddhatek Ganpati | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Siddhatek Ganpati with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/228.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinsiddhatekganpati;